import {ROLE_FOR_ADMINISTRATOR_REAL, ROLE_FOR_RESIDENT_REAL} from '../../../CodeMaster'

// 権限
export const AUTHORITY_VIEW: number = 1
export const AUTHORITY_EDIT: number = 2
export const AUTHORITY_CSV_OUTPUT = 4
export const AUTHORITY_CONTRIBUTE = 6
export const AUTHORITY_CANCEL_RESERVATION = 7
export const AUTHORITY_APPROVAL_APPLICATION = 9
export const AUTHORITY_VIEW_MEETING_ASSOC_DIRECTOR = 10
export const AUTHORITY_EDIT_MEETING_ASSOC_DIRECTOR = 11
export const AUTHORITY_MANAGE_ATTENDANCE_ASSOC_DIRECTOR = 12
export const AUTHORITY_POST_COMMENT = 13
export const AUTHORITY_RECEPTION_APPLICATION = 15
export const AUTHORITY_APPROVAL_DELEGATE_APPLICATION = 16
export const AUTHORITY_APPLICATION_PRINT_APPLICATION = 17
export const AUTHORITY_ISSUE = 18
export const AUTHORITY_VIEW_COMPLETE_ONLY = 19
export const AUTHORITY_DELETE_COMMENT = 21
export const AUTHORITY_REGISTER_TOPIC = 22
export const AUTHORITY_DELETE_TOPIC = 23
export const AUTHORITY_EXCEL_OUTPUT = 26
// 機能
export const FUNCTION_DIV_ID_FACILITY_SETTING: number = 7
export const FUNCTION_DIV_ID_FACILITY_DESCRIPTION: number = 8
export const FUNCTION_DIV_ID_CLOSED_SETTING: number = 10
export const FUNCTION_DIV_ID_RESIDENT_USER: number = 1
export const FUNCTION_DIV_ID_AGENT_RESERVATION: number = 4
export const FUNCTION_DIV_ID_ADDITIONAL_BILLING: number = 5
export const FUNCTION_DIV_ID_RESERVATION_LIST: number = 6
export const FUNCTION_DIV_ID_BILLING_DATA: number = 11
export const FUNCTION_DIV_ID_EQUIPMENT_FACILITY = 7
export const FUNCTION_DIV_ID_ADMIN_FACILITY_DESCRIPTION = 8
export const FUNCTION_DIV_ID_FACILITY_TOTAL_DESCRIPTION = 9
export const FUNCTION_DIV_ID_FACILITY_CLOSED_SETTING = 10
export const FUNCTION_DIV_ID_BOARD_MANAGEMENT = 14
export const FUNCTION_DIV_ID_ASSOC_DIRECTOR = 32
export const FUNCTION_DIV_ID_APPLICATION = 37
export const FUNCTION_DIV_ID_ASSOC = 56
export const FUNCTION_DIV_ID_OWNERSHIP_TRANSFER = 61
export const FUNCTION_DIV_ID_DISASTER_PREVENTION = 71
export const FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING = 72
export const FUNCTION_DIV_ID_GENERAL_MEETING = 75
export const FUNCTION_DIV_ID_UNIT_OWNER_MANAGEMENT = 77
// 機能（居住者）
export const FUNCTION_DIV_ID_FOR_RESIDENT_RESIDENT_USER = 15
export const FUNCTION_DIV_ID_FOR_RESIDENT_FACILITY_RESERVE = 16
export const FUNCTION_DIV_ID_FOR_RESIDENT_MESSAGE = 17
export const FUNCTION_DIV_ID_FOR_RESIDENT_CALENDAR_MANAGEMENT = 18
export const FUNCTION_DIV_ID_FOR_RESIDENT_LIFE_NOTE_MANAGEMENT = 19
export const FUNCTION_DIV_ID_FOR_RESIDENT_APART_INFO = 20
export const FUNCTION_DIV_ID_FOR_RESIDENT_ASSOC_INFO = 21
export const FUNCTION_DIV_ID_FOR_RESIDENT_ACCOUNT_TRANSFER = 35
export const FUNCTION_DIV_ID_FOR_RESIDENT_ASSOC_DIRECTOR = 34
export const FUNCTION_DIV_ID_FOR_RESIDENT_CONTACT_ADDRESS_ON_EMERGENCY = 38
export const FUNCTION_DIV_ID_FOR_RESIDENT_PARKING_USE_APPLICATION = 39
export const FUNCTION_DIV_ID_FOR_RESIDENT_PARKING_WITHDRAWAL_APPLICATION = 40
export const FUNCTION_DIV_ID_FOR_RESIDENT_CAR_CHANGE_NOTIFICATION = 41
export const FUNCTION_DIV_ID_FOR_RESIDENT_BICYCLE_PARKING_USE_APPLICATION = 42
export const FUNCTION_DIV_ID_FOR_RESIDENT_BICYCLE_PARKING_WITHDRAWAL_APPLICATION = 43
export const FUNCTION_DIV_ID_FOR_RESIDENT_BIKE_PARKING_USE_APPLICATION = 44
export const FUNCTION_DIV_ID_FOR_RESIDENT_BIKE_PARKING_WITHDRAWAL_APPLICATION = 45
export const FUNCTION_DIV_ID_FOR_RESIDENT_BIKE_CHANGE_NOTIFICATION = 46
export const FUNCTION_DIV_ID_FOR_RESIDENT_PET_BREEDING_APPLICATION = 47
export const FUNCTION_DIV_ID_FOR_RESIDENT_PET_MEDICAL_CHECK_UP_REPORT = 48
export const FUNCTION_DIV_ID_FOR_RESIDENT_PET_BREEDING_STOP = 49
export const FUNCTION_DIV_ID_FOR_RESIDENT_CONSTRUCTION_APPLICATION = 50
export const FUNCTION_DIV_ID_FOR_RESIDENT_CONSTRUCTION_COMPLETE_NOTIFICATION = 51
export const FUNCTION_DIV_ID_FOR_RESIDENT_WINDOW_GLASS_FILM_PASTE_NOTIFICATION = 52
export const FUNCTION_DIV_ID_FOR_RESIDENT_LONG_TERM_ABSENCE_NOTIFICATION = 53
export const FUNCTION_DIV_ID_FOR_RESIDENT_HEAVY_LOADS_CARRY_IN_NOTIFICATION = 54
export const FUNCTION_DIV_ID_FOR_RESIDENT_BROWSE_APPLICATION = 55
export const FUNCTION_DIV_ID_FOR_RESIDENT_BILLING_AMOUNT = 63
export const FUNCTION_DIV_ID_FOR_RESIDENT_RECEIPT = 64
export const FUNCTION_DIV_ID_FOR_RESIDENT_ACCOUNT_INFORMATION = 65
export const FUNCTION_DIV_ID_FOR_RESIDENT_GENERAL_MEETING = 67
export const FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_PREVENTION = 73
export const FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_INFORMATION_SHARING = 74
export const FUNCTION_DIV_ID_FOR_RESIDENT_UNIT_OWNER_CONFIRMATION = 76

/* 編集不可の権限(管理者権限)
 * key：ロール
 * value:(key: 機能, value: 権限)
 * 権限の全てが編集不可の場合、all を指定
 */
export const NON_EDIT_AUTHORITY_FOR_ADMIN = new Map<ROLE_FOR_ADMINISTRATOR_REAL,
    Map<number, number[] | 'all'>>([
        [ROLE_FOR_ADMINISTRATOR_REAL.CALL_CENTER,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_ASSOC_DIRECTOR, [
                    AUTHORITY_EDIT_MEETING_ASSOC_DIRECTOR,
                    AUTHORITY_MANAGE_ATTENDANCE_ASSOC_DIRECTOR,
                    AUTHORITY_POST_COMMENT]
                ],
                [FUNCTION_DIV_ID_APPLICATION, [AUTHORITY_APPROVAL_APPLICATION]],
                [FUNCTION_DIV_ID_ASSOC, 'all'],
                [FUNCTION_DIV_ID_OWNERSHIP_TRANSFER, 'all'],
                [FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING, [AUTHORITY_CSV_OUTPUT]],
                [
                    FUNCTION_DIV_ID_GENERAL_MEETING,
                    [
                        AUTHORITY_CSV_OUTPUT,
                        AUTHORITY_EXCEL_OUTPUT
                    ]
                ],
            ])
        ],
        [ROLE_FOR_ADMINISTRATOR_REAL.FRONT_STAFF,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_APPLICATION, [AUTHORITY_APPROVAL_APPLICATION]]
            ])
        ],
        [ROLE_FOR_ADMINISTRATOR_REAL.LIFE_MANAGER,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_APPLICATION, [AUTHORITY_APPROVAL_APPLICATION]],
                [FUNCTION_DIV_ID_DISASTER_PREVENTION, [AUTHORITY_EDIT]],
                [FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING, [
                    AUTHORITY_CSV_OUTPUT,
                    AUTHORITY_POST_COMMENT,
                    AUTHORITY_DELETE_COMMENT,
                    AUTHORITY_REGISTER_TOPIC,
                    AUTHORITY_DELETE_TOPIC
                ]]
            ])
        ],
        [ROLE_FOR_ADMINISTRATOR_REAL.CONCIERGE,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_APPLICATION, [AUTHORITY_APPROVAL_APPLICATION]],
                [FUNCTION_DIV_ID_OWNERSHIP_TRANSFER, 'all'],
                [FUNCTION_DIV_ID_DISASTER_PREVENTION, [AUTHORITY_EDIT]],
                [FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING, [
                    AUTHORITY_CSV_OUTPUT,
                    AUTHORITY_POST_COMMENT,
                    AUTHORITY_DELETE_COMMENT,
                    AUTHORITY_REGISTER_TOPIC,
                    AUTHORITY_DELETE_TOPIC
                ]]
            ])
        ],
        [ROLE_FOR_ADMINISTRATOR_REAL.ASSOC_CHAIRMAN,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_RESIDENT_USER, 'all'],
                [FUNCTION_DIV_ID_AGENT_RESERVATION, 'all'],
                [FUNCTION_DIV_ID_ADDITIONAL_BILLING, 'all'],
                [FUNCTION_DIV_ID_RESERVATION_LIST, 'all'],
                [FUNCTION_DIV_ID_EQUIPMENT_FACILITY, 'all'],
                [FUNCTION_DIV_ID_ADMIN_FACILITY_DESCRIPTION, 'all'],
                [FUNCTION_DIV_ID_FACILITY_TOTAL_DESCRIPTION, 'all'],
                [FUNCTION_DIV_ID_FACILITY_CLOSED_SETTING, 'all'],
                [FUNCTION_DIV_ID_BILLING_DATA, 'all'],
                [FUNCTION_DIV_ID_BOARD_MANAGEMENT, 'all'],
                [FUNCTION_DIV_ID_APPLICATION, [
                    AUTHORITY_RECEPTION_APPLICATION,
                    AUTHORITY_APPROVAL_DELEGATE_APPLICATION]
                ],
                [FUNCTION_DIV_ID_ASSOC, [AUTHORITY_EDIT]],
                [FUNCTION_DIV_ID_OWNERSHIP_TRANSFER, 'all'],
                [FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING, [
                    AUTHORITY_CSV_OUTPUT,
                    AUTHORITY_POST_COMMENT,
                    AUTHORITY_REGISTER_TOPIC
                ]],
                [FUNCTION_DIV_ID_GENERAL_MEETING, 'all'],
                [FUNCTION_DIV_ID_UNIT_OWNER_MANAGEMENT, 'all'],
            ])
        ],
        [ROLE_FOR_ADMINISTRATOR_REAL.ASSOC_VICE_CHAIRMAN,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_RESIDENT_USER, 'all'],
                [FUNCTION_DIV_ID_AGENT_RESERVATION, 'all'],
                [FUNCTION_DIV_ID_ADDITIONAL_BILLING, 'all'],
                [FUNCTION_DIV_ID_RESERVATION_LIST, 'all'],
                [FUNCTION_DIV_ID_EQUIPMENT_FACILITY, 'all'],
                [FUNCTION_DIV_ID_ADMIN_FACILITY_DESCRIPTION, 'all'],
                [FUNCTION_DIV_ID_FACILITY_TOTAL_DESCRIPTION, 'all'],
                [FUNCTION_DIV_ID_FACILITY_CLOSED_SETTING, 'all'],
                [FUNCTION_DIV_ID_BILLING_DATA, 'all'],
                [FUNCTION_DIV_ID_BOARD_MANAGEMENT, 'all'],
                [FUNCTION_DIV_ID_APPLICATION, [
                    AUTHORITY_RECEPTION_APPLICATION,
                    AUTHORITY_APPROVAL_DELEGATE_APPLICATION]
                ],
                [FUNCTION_DIV_ID_ASSOC, [AUTHORITY_EDIT]],
                [FUNCTION_DIV_ID_OWNERSHIP_TRANSFER, 'all'],
                [FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING, [
                    AUTHORITY_CSV_OUTPUT,
                    AUTHORITY_POST_COMMENT,
                    AUTHORITY_REGISTER_TOPIC
                ]],
                [FUNCTION_DIV_ID_GENERAL_MEETING, 'all'],
                [FUNCTION_DIV_ID_UNIT_OWNER_MANAGEMENT, 'all'],
            ])
        ],
        [ROLE_FOR_ADMINISTRATOR_REAL.ASSOC,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_RESIDENT_USER, 'all'],
                [FUNCTION_DIV_ID_AGENT_RESERVATION, 'all'],
                [FUNCTION_DIV_ID_ADDITIONAL_BILLING, 'all'],
                [FUNCTION_DIV_ID_RESERVATION_LIST, 'all'],
                [FUNCTION_DIV_ID_EQUIPMENT_FACILITY, 'all'],
                [FUNCTION_DIV_ID_ADMIN_FACILITY_DESCRIPTION, 'all'],
                [FUNCTION_DIV_ID_FACILITY_TOTAL_DESCRIPTION, 'all'],
                [FUNCTION_DIV_ID_FACILITY_CLOSED_SETTING, 'all'],
                [FUNCTION_DIV_ID_BILLING_DATA, 'all'],
                [FUNCTION_DIV_ID_BOARD_MANAGEMENT, 'all'],
                [FUNCTION_DIV_ID_APPLICATION, [
                    AUTHORITY_RECEPTION_APPLICATION,
                    AUTHORITY_APPROVAL_APPLICATION,
                    AUTHORITY_APPROVAL_DELEGATE_APPLICATION]
                ],
                [FUNCTION_DIV_ID_ASSOC, [AUTHORITY_EDIT]],
                [FUNCTION_DIV_ID_OWNERSHIP_TRANSFER, 'all'],
                [FUNCTION_DIV_ID_DISASTER_INFORMATION_SHARING, [
                    AUTHORITY_CSV_OUTPUT,
                    AUTHORITY_POST_COMMENT,
                    AUTHORITY_REGISTER_TOPIC
                ]],
                [FUNCTION_DIV_ID_GENERAL_MEETING, 'all'],
                [FUNCTION_DIV_ID_UNIT_OWNER_MANAGEMENT, 'all'],
            ])
        ]
    ]
)

/* 編集不可の権限(居住者権限)
 * key：ロール
 * value:(key: 機能, value: 権限)
 * 権限の全てが編集不可の場合、all を指定
 */
export const NON_EDIT_AUTHORITY_FOR_RESIDENT = new Map<ROLE_FOR_RESIDENT_REAL,
    Map<number, number[] | 'all'>>([
        [ROLE_FOR_RESIDENT_REAL.RESIDENT,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_FOR_RESIDENT_ASSOC_DIRECTOR, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_INFORMATION_SHARING, [AUTHORITY_REGISTER_TOPIC]]
            ])
        ],
        [ROLE_FOR_RESIDENT_REAL.APPROPRIATOR,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_FOR_RESIDENT_ASSOC_DIRECTOR, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_INFORMATION_SHARING, [AUTHORITY_REGISTER_TOPIC]],
                [FUNCTION_DIV_ID_FOR_RESIDENT_GENERAL_MEETING, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_UNIT_OWNER_CONFIRMATION, 'all'],
            ])
        ],
        [ROLE_FOR_RESIDENT_REAL.OWNER,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_FOR_RESIDENT_ASSOC_DIRECTOR, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_INFORMATION_SHARING, [AUTHORITY_REGISTER_TOPIC]]
            ])
        ],
        [ROLE_FOR_RESIDENT_REAL.ASSOC,
            new Map<number, number[] | 'all'>([
                [FUNCTION_DIV_ID_FOR_RESIDENT_RESIDENT_USER, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_FACILITY_RESERVE, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_MESSAGE, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_CALENDAR_MANAGEMENT, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_LIFE_NOTE_MANAGEMENT, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_APART_INFO, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_ASSOC_INFO, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_ACCOUNT_TRANSFER, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_CONTACT_ADDRESS_ON_EMERGENCY, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_PARKING_USE_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_PARKING_WITHDRAWAL_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_CAR_CHANGE_NOTIFICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_BICYCLE_PARKING_USE_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_BICYCLE_PARKING_WITHDRAWAL_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_BIKE_PARKING_USE_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_BIKE_PARKING_WITHDRAWAL_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_BIKE_CHANGE_NOTIFICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_PET_BREEDING_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_PET_MEDICAL_CHECK_UP_REPORT, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_PET_BREEDING_STOP, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_CONSTRUCTION_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_CONSTRUCTION_COMPLETE_NOTIFICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_WINDOW_GLASS_FILM_PASTE_NOTIFICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_LONG_TERM_ABSENCE_NOTIFICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_HEAVY_LOADS_CARRY_IN_NOTIFICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_BROWSE_APPLICATION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_PREVENTION, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_DISASTER_INFORMATION_SHARING, [
                    AUTHORITY_VIEW,
                    AUTHORITY_POST_COMMENT
                ]],
                [FUNCTION_DIV_ID_FOR_RESIDENT_GENERAL_MEETING, 'all'],
                [FUNCTION_DIV_ID_FOR_RESIDENT_UNIT_OWNER_CONFIRMATION, 'all'],
            ])
        ],
    ]
)
